// AdminPage.jsx

// Dependencies
import React, { useEffect, useState } from 'react';
import { getUsers } from '@/services/userService';
import PageHeading from '@/components/common/PageHeading';
import Admin from '@/components/data/common/admin/Admin';
// Styling
import { adminCss } from '@digital_monorepo/styling';

const AdminPage = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const usersData = await getUsers();
        setUsers(usersData);
      } catch (error) {
        console.error('Error fetching users:', error);
        setError('Failed to load users data. Please try again later.');
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);

  if (loading) {
    return (
      <div className={adminCss.adminContainer}>
        <div className='text-center py-5'>
          <div className='spinner-border text-primary' role='status'>
            <span className='visually-hidden'>Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={adminCss.adminContainer}>
        <div className='alert alert-danger' role='alert'>
          {error}
        </div>
      </div>
    );
  }

  return (
    <div className='workspace-management-page'>
      <PageHeading title='User management' />
      <Admin data={users} />
    </div>
  );
};

export default AdminPage;
